module.exports = __webpack_public_path__ + "static/media/Belmont.b6b209e3.png";